<script lang="ts" setup>
import CollapseFieldset from '@/components/CollapseFieldset.vue';
import { inject, ref, watch } from 'vue';
import type { Ref } from 'vue';
import type { IManifest } from '@/types/IManifest';

const manifest = inject('manifest') as Ref<IManifest>;
const androidARModel = ref(manifest.value.ar.android);
const iosARModel = ref(manifest.value.ar.ios);

watch(androidARModel, (newValue: string | undefined) => {
  if (newValue === '') manifest.value.ar.android = undefined;
  else manifest.value.ar.android = newValue;
});

watch(iosARModel, (newValue: string | undefined) => {
  if (newValue === '') manifest.value.ar.ios = undefined;
  else manifest.value.ar.ios = newValue;
});
</script>

<template>
  <CollapseFieldset>
    <template #legend>
      AR Configuration
    </template>

    <div class="flex flex-col mb-1">
      <label for="ar-ios" class="text-xs">iOS AR Model</label>
      <input id="ar-ios" v-model="iosARModel" type="text" class="border p-1 text-xs">
    </div>

    <div class="flex flex-col mb-1">
      <label for="ar-android" class="text-xs">Android AR Model</label>
      <input id="ar-android" v-model="androidARModel" type="text" class="border p-1 text-xs">
    </div>
  </CollapseFieldset>
</template>
